import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" clip-path=\"url(#i-755492014__a)\"><path d=\"m14 30.854 5.717 8.113a2.447 2.447 0 0 0 3.983.119L42 15.932\"></path><path d=\"M1.75 27.998a26.25 26.25 0 1 0 52.5 0 26.25 26.25 0 0 0-52.5 0\"></path></g><defs><clipPath id=\"i-755492014__a\"><path fill=\"#fff\" d=\"M0 0h56v56H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }